/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusInvoiceInfoDto
 */
export interface NovitusInvoiceInfoDto {
    /**
     * Numer faktury (1-56 znaków)
     * @type {string}
     * @memberof NovitusInvoiceInfoDto
     */
    number: string;
    /**
     * Ilość kopii (0-10)
     * @type {number}
     * @memberof NovitusInvoiceInfoDto
     */
    copy_count?: number;
    /**
     * Data sprzedaży w formacie dd/MM/yyyy
     * @type {string}
     * @memberof NovitusInvoiceInfoDto
     */
    date_of_sell: string;
    /**
     * Data płatności w formacie dd/MM/yyyy
     * @type {string}
     * @memberof NovitusInvoiceInfoDto
     */
    date_of_payment?: string;
    /**
     * Forma płatności (1-20 znaków)
     * @type {string}
     * @memberof NovitusInvoiceInfoDto
     */
    payment_form: string;
    /**
     * Zapłacono (1-29 znaków)
     * @type {string}
     * @memberof NovitusInvoiceInfoDto
     */
    paid?: string;
}

/**
 * Check if a given object implements the NovitusInvoiceInfoDto interface.
 */
export function instanceOfNovitusInvoiceInfoDto(value: object): value is NovitusInvoiceInfoDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('date_of_sell' in value) || value['date_of_sell'] === undefined) return false;
    if (!('payment_form' in value) || value['payment_form'] === undefined) return false;
    return true;
}

export function NovitusInvoiceInfoDtoFromJSON(json: any): NovitusInvoiceInfoDto {
    return NovitusInvoiceInfoDtoFromJSONTyped(json, false);
}

export function NovitusInvoiceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusInvoiceInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'copy_count': json['copy_count'] == null ? undefined : json['copy_count'],
        'date_of_sell': json['date_of_sell'],
        'date_of_payment': json['date_of_payment'] == null ? undefined : json['date_of_payment'],
        'payment_form': json['payment_form'],
        'paid': json['paid'] == null ? undefined : json['paid'],
    };
}

export function NovitusInvoiceInfoDtoToJSON(value?: NovitusInvoiceInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'copy_count': value['copy_count'],
        'date_of_sell': value['date_of_sell'],
        'date_of_payment': value['date_of_payment'],
        'payment_form': value['payment_form'],
        'paid': value['paid'],
    };
}

